import { Map, Set, List, fromJS } from 'immutable'
import actionTypes from '../../actions/actionTypes'

const INIT_STATE = Map({
    activeUpdateText:     null,
    displayUpdateHistory: false,
    openPanel:            null,
    openTheatres:         Set(),
    selectedCinemaId:     null,
    readVersions:         List(
        (window.pmkinoClientVars && window.pmkinoClientVars.changelogRead) || []
    ),
    ignoredMovieIds:      List(
        (window.pmkinoClientVars && window.pmkinoClientVars.ignoredMovies) || []
    ),
    weeks:                null,
})

const dashboardUiReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes.DASHBOARD_SET_ACTIVE_UPDATETEXT:
            return state.set('activeUpdateText', action.payload.activeUpdateTextID)
        case actionTypes.DASHBOARD_SET_DISPLAY_UPDATEHISTORY:
            return state.set('displayUpdateHistory', action.payload.displayUpdateHistory)
        case actionTypes.DASHBOARD_TOGGLE_PANEL: {
            const next = state.get('openPanel') === action.panelId ? null : action.panelId
            return state.set('openPanel', next)
        }
        case actionTypes.DASHBOARD_TOGGLE_THEATRE: {
            const theatres = state.get('openTheatres')
            const updated  = theatres.has(action.theatreId)
                ? theatres.delete(action.theatreId)
                : theatres.add(action.theatreId)
            return state.set('openTheatres', updated)
        }
        case actionTypes.DASHBOARD_SET_CINEMA_FILTER: {
            return state.set('selectedCinemaId', action.cinemaId)
        }
        case actionTypes.CHANGELOG_MARK_READ: {
            const rv = state.get('readVersions')
            if (rv.includes(action.version)) return state
            return state.set('readVersions', rv.push(action.version))
        }
        case actionTypes.CHANGELOG_MARK_ALL_READ: {
            const rv = state.get('readVersions')
            const merged = rv.concat(
                List(action.versions).filter(v => !rv.includes(v))
            )
            return state.set('readVersions', merged)
        }
        case actionTypes.DASHBOARD_IGNORE_MOVIE: {
            const ids = state.get('ignoredMovieIds')
            if (ids.includes(action.movieId)) return state
            return state.set('ignoredMovieIds', ids.push(action.movieId))
        }
        case actionTypes.DASHBOARD_UNIGNORE_MOVIE: {
            return state.set('ignoredMovieIds', state.get('ignoredMovieIds').filter(id => id !== action.movieId))
        }
        case actionTypes.DASHBOARD_SET_IGNORED_MOVIES: {
            return state.set('ignoredMovieIds', List(action.ids))
        }
        case actionTypes.DASHBOARD_SET_WEEKS: {
            return state.set('weeks', fromJS(action.weeks))
        }
        default:
            return state
    }
}

export default dashboardUiReducer
